define('SageDotCom/DataLayer/Events/ctaClick',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function CtaClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "cta_click"; // overwrite name
    }

    CtaClickEvent.prototype = Object.create(EventBase.prototype);

    CtaClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label) {
        var eventData = {
            'event_name': this.getName()
        }

        if (scope) {
            var lbl = label || $(scope).attr("data-title") || $(scope).text() || $("a:first", scope).text() || $("button:first", scope).text() || "";

            eventData = $.extend(eventData, {
                'destination_url': $(scope).attr("href") || $("a:first", scope).attr("href") || $("button:first", scope).attr("href") || "",
                'element_text': this.cleanseString(lbl.trim()), // strip any html
                'element_id': this.getId(scope),
                'element_class': $(scope).attr("class") || "",
            });
        }

        return eventData;
    }

    return new CtaClickEvent();
});
